import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // CRITICAL FIX: Import ONLY for side effects (configuration)
import i18n from 'i18next'; // NEW: Import the configured instance directly from the package
import { I18nextProvider } from 'react-i18next'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Wrap your App component with I18nextProvider */}
    <I18nextProvider i18n={i18n}> 
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

reportWebVitals();